<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  lead: {
    type: Object,
    default: null,
  },
});

const route = useRoute();

const titleize = value =>
  value
    ? value
        .toString()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase())
    : '';

const fields = computed(() => {
  if (!props.lead) return [];
  return [
    { key: 'platform', label: 'PLATFORM', value: props.lead.platform },
    { key: 'budget', label: 'BUDGET', value: props.lead.budget },
    { key: 'timeline', label: 'TIMELINE', value: props.lead.timeline },
    { key: 'website', label: 'WEBSITE', value: props.lead.website },
  ].filter(field => field.value);
});

const leadsPath = computed(() => ({
  name: 'leads_index',
  params: { accountId: route.params.accountId },
}));
</script>

<template>
  <div v-if="lead" class="flex flex-col gap-3">
    <div class="flex flex-wrap items-center gap-1.5">
      <span
        class="px-1.5 py-0.5 text-xs font-medium rounded bg-n-brand/10 text-n-brand"
      >
        {{ titleize(lead.status) }}
      </span>
      <span class="px-1.5 py-0.5 text-xs rounded bg-n-alpha-2 text-n-slate-11">
        {{ titleize(lead.category) }}
      </span>
    </div>
    <p
      v-if="lead.service_interest"
      class="mb-0 text-sm text-n-slate-12 break-words"
    >
      {{ lead.service_interest }}
    </p>
    <dl v-if="fields.length" class="grid grid-cols-2 gap-x-3 gap-y-2 mb-0">
      <div v-for="field in fields" :key="field.key" class="min-w-0">
        <dt class="text-xs text-n-slate-10">
          {{ $t(`CONVERSATION_SIDEBAR.LEAD_PANEL.FIELDS.${field.label}`) }}
        </dt>
        <dd class="mb-0 text-sm text-n-slate-12 break-words">
          {{ field.value }}
        </dd>
      </div>
    </dl>
    <p v-if="lead.summary" class="mb-0 text-sm leading-relaxed text-n-slate-11">
      {{ lead.summary }}
    </p>
    <router-link
      :to="leadsPath"
      class="self-start text-xs text-n-brand hover:underline"
    >
      {{ $t('CONVERSATION_SIDEBAR.LEAD_PANEL.OPEN_LEADS') }}
    </router-link>
  </div>
  <p v-else class="mb-0 text-sm text-n-slate-11">
    {{ $t('CONVERSATION_SIDEBAR.LEAD_PANEL.NO_LEAD') }}
  </p>
</template>
